import { useMutation, useQueryClient } from '@tanstack/react-query';
import { orpc, rpcClient } from '@/api/rpc/client';
import { useToast } from '@/context/ToastContext';
import type { FeedbackSubjectType } from '@erp/rpc';

export interface DeleteFeedbackInput {
  feedbackId: string;
  // Used to scope the cache invalidation after deletion.
  subjectType: FeedbackSubjectType;
  subjectId: string;
}

export function useDeleteFeedback() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  return useMutation<{ success: boolean }, Error, DeleteFeedbackInput>({
    mutationFn: async (input) => {
      return await rpcClient.core.userFeedback.delete({
        feedbackId: input.feedbackId,
      });
    },
    onSuccess: (_data, input) => {
      void queryClient.invalidateQueries({
        queryKey: orpc.core.userFeedback.getMyForSubject.key({
          input: {
            subjectType: input.subjectType,
            subjectId: input.subjectId,
          },
        }),
      });
    },
    onError: (error) => {
      showToast({
        title: 'Could not delete feedback',
        message: error.message,
        color: 'error',
        icon: 'x',
      });
    },
  });
}
